import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../app/store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../app/store/modules/voice/index.ts'), 'modules/voice/index.ts')
  resolveStoreModules(require('../app/store/modules/summary/index.ts'), 'modules/summary/index.ts')
  resolveStoreModules(require('../app/store/modules/subscription/index.ts'), 'modules/subscription/index.ts')
  resolveStoreModules(require('../app/store/modules/profile/index.ts'), 'modules/profile/index.ts')
  resolveStoreModules(require('../app/store/modules/price/index.ts'), 'modules/price/index.ts')
  resolveStoreModules(require('../app/store/modules/presentation/index.ts'), 'modules/presentation/index.ts')
  resolveStoreModules(require('../app/store/modules/pager/index.ts'), 'modules/pager/index.ts')
  resolveStoreModules(require('../app/store/modules/orderSummary/index.ts'), 'modules/orderSummary/index.ts')
  resolveStoreModules(require('../app/store/modules/orderItem/index.ts'), 'modules/orderItem/index.ts')
  resolveStoreModules(require('../app/store/modules/order/index.ts'), 'modules/order/index.ts')
  resolveStoreModules(require('../app/store/modules/news/index.ts'), 'modules/news/index.ts')
  resolveStoreModules(require('../app/store/modules/meta/index.ts'), 'modules/meta/index.ts')
  resolveStoreModules(require('../app/store/modules/memberAddress/index.ts'), 'modules/memberAddress/index.ts')
  resolveStoreModules(require('../app/store/modules/group/index.ts'), 'modules/group/index.ts')
  resolveStoreModules(require('../app/store/modules/faq/index.ts'), 'modules/faq/index.ts')
  resolveStoreModules(require('../app/store/modules/family/index.ts'), 'modules/family/index.ts')
  resolveStoreModules(require('../app/store/modules/event/index.ts'), 'modules/event/index.ts')
  resolveStoreModules(require('../app/store/modules/cart/index.ts'), 'modules/cart/index.ts')
  resolveStoreModules(require('../app/store/modules/cart/mutations.ts'), 'modules/cart/mutations.ts')
  resolveStoreModules(require('../app/store/modules/cart/state.ts'), 'modules/cart/state.ts')
  resolveStoreModules(require('../app/store/modules/cart/types.ts'), 'modules/cart/types.ts')
  resolveStoreModules(require('../app/store/modules/event/mutations.ts'), 'modules/event/mutations.ts')
  resolveStoreModules(require('../app/store/modules/event/state.ts'), 'modules/event/state.ts')
  resolveStoreModules(require('../app/store/modules/event/types.ts'), 'modules/event/types.ts')
  resolveStoreModules(require('../app/store/modules/family/mutations.ts'), 'modules/family/mutations.ts')
  resolveStoreModules(require('../app/store/modules/family/state.ts'), 'modules/family/state.ts')
  resolveStoreModules(require('../app/store/modules/family/types.ts'), 'modules/family/types.ts')
  resolveStoreModules(require('../app/store/modules/faq/mutations.ts'), 'modules/faq/mutations.ts')
  resolveStoreModules(require('../app/store/modules/faq/state.ts'), 'modules/faq/state.ts')
  resolveStoreModules(require('../app/store/modules/faq/types.ts'), 'modules/faq/types.ts')
  resolveStoreModules(require('../app/store/modules/group/mutations.ts'), 'modules/group/mutations.ts')
  resolveStoreModules(require('../app/store/modules/group/state.ts'), 'modules/group/state.ts')
  resolveStoreModules(require('../app/store/modules/group/types.ts'), 'modules/group/types.ts')
  resolveStoreModules(require('../app/store/modules/memberAddress/mutations.ts'), 'modules/memberAddress/mutations.ts')
  resolveStoreModules(require('../app/store/modules/memberAddress/state.ts'), 'modules/memberAddress/state.ts')
  resolveStoreModules(require('../app/store/modules/memberAddress/types.ts'), 'modules/memberAddress/types.ts')
  resolveStoreModules(require('../app/store/modules/meta/mutations.ts'), 'modules/meta/mutations.ts')
  resolveStoreModules(require('../app/store/modules/meta/state.ts'), 'modules/meta/state.ts')
  resolveStoreModules(require('../app/store/modules/meta/types.ts'), 'modules/meta/types.ts')
  resolveStoreModules(require('../app/store/modules/news/mutations.ts'), 'modules/news/mutations.ts')
  resolveStoreModules(require('../app/store/modules/news/state.ts'), 'modules/news/state.ts')
  resolveStoreModules(require('../app/store/modules/news/types.ts'), 'modules/news/types.ts')
  resolveStoreModules(require('../app/store/modules/order/mutations.ts'), 'modules/order/mutations.ts')
  resolveStoreModules(require('../app/store/modules/order/state.ts'), 'modules/order/state.ts')
  resolveStoreModules(require('../app/store/modules/order/types.ts'), 'modules/order/types.ts')
  resolveStoreModules(require('../app/store/modules/orderItem/mutations.ts'), 'modules/orderItem/mutations.ts')
  resolveStoreModules(require('../app/store/modules/orderItem/state.ts'), 'modules/orderItem/state.ts')
  resolveStoreModules(require('../app/store/modules/orderItem/types.ts'), 'modules/orderItem/types.ts')
  resolveStoreModules(require('../app/store/modules/orderSummary/mutations.ts'), 'modules/orderSummary/mutations.ts')
  resolveStoreModules(require('../app/store/modules/orderSummary/state.ts'), 'modules/orderSummary/state.ts')
  resolveStoreModules(require('../app/store/modules/orderSummary/types.ts'), 'modules/orderSummary/types.ts')
  resolveStoreModules(require('../app/store/modules/pager/mutations.ts'), 'modules/pager/mutations.ts')
  resolveStoreModules(require('../app/store/modules/pager/state.ts'), 'modules/pager/state.ts')
  resolveStoreModules(require('../app/store/modules/pager/types.ts'), 'modules/pager/types.ts')
  resolveStoreModules(require('../app/store/modules/presentation/mutations.ts'), 'modules/presentation/mutations.ts')
  resolveStoreModules(require('../app/store/modules/presentation/state.ts'), 'modules/presentation/state.ts')
  resolveStoreModules(require('../app/store/modules/presentation/types.ts'), 'modules/presentation/types.ts')
  resolveStoreModules(require('../app/store/modules/price/mutations.ts'), 'modules/price/mutations.ts')
  resolveStoreModules(require('../app/store/modules/price/state.ts'), 'modules/price/state.ts')
  resolveStoreModules(require('../app/store/modules/price/types.ts'), 'modules/price/types.ts')
  resolveStoreModules(require('../app/store/modules/profile/mutations.ts'), 'modules/profile/mutations.ts')
  resolveStoreModules(require('../app/store/modules/profile/state.ts'), 'modules/profile/state.ts')
  resolveStoreModules(require('../app/store/modules/profile/types.ts'), 'modules/profile/types.ts')
  resolveStoreModules(require('../app/store/modules/subscription/mutations.ts'), 'modules/subscription/mutations.ts')
  resolveStoreModules(require('../app/store/modules/subscription/state.ts'), 'modules/subscription/state.ts')
  resolveStoreModules(require('../app/store/modules/subscription/types.ts'), 'modules/subscription/types.ts')
  resolveStoreModules(require('../app/store/modules/summary/mutations.ts'), 'modules/summary/mutations.ts')
  resolveStoreModules(require('../app/store/modules/summary/state.ts'), 'modules/summary/state.ts')
  resolveStoreModules(require('../app/store/modules/summary/types.ts'), 'modules/summary/types.ts')
  resolveStoreModules(require('../app/store/modules/voice/mutations.ts'), 'modules/voice/mutations.ts')
  resolveStoreModules(require('../app/store/modules/voice/state.ts'), 'modules/voice/state.ts')
  resolveStoreModules(require('../app/store/modules/voice/types.ts'), 'modules/voice/types.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
